import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.date.to-json.js";
// Vendors
import Keycloak from 'keycloak-js';
import cookies from "../cookies/cookies";
import session from "../session/session.utils";
// Utils
import { getCookieDomain, isCurrentDomain } from "../session/utils/session.utils.utils";
// Constants
import constants from "./constants/keycloak.constants";
import storageConstants from "../../constants/storage";
// Types

var keycloak;
var promiseCallback = function promiseCallback(_ref) {
  var callback = _ref.callback,
    onError = _ref.onError;
  var _keycloak = keycloak,
    authenticated = _keycloak.authenticated,
    token = _keycloak.token;
  if (token && authenticated) {
    var domain = cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN);
    if (!isCurrentDomain(domain)) {
      session.clearSessionData();
      var domainValue = window.location.hostname;
      cookies.setCookie({
        name: storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN,
        value: domainValue,
        domain: getCookieDomain()
      });
    }
    cookies.setCookie({
      name: storageConstants.COOKIES_IDS.ACCESS_TOKEN,
      value: token,
      domain: getCookieDomain()
    });
    callback && callback([{
      accessToken: token
    }]);
    keycloak.onAuthRefreshSuccess = function () {
      return window.console.log('Keycloak token refreshed!!');
    };
    keycloak.onAuthSuccess = function () {
      return window.console.log('Keycloak authed successfully!!');
    };
    keycloak.onAuthError = function (error) {
      return window.console.log('Keycloak authed successfully!!' + JSON.stringify(error));
    };
    keycloak.onAuthRefreshError = function (error) {
      return window.console.log('Keycloak token not refreshed!!' + JSON.stringify(error));
    };
    return true;
  } else {
    onError && onError();
    return false;
  }
};
var doKeycloakLogout = function doKeycloakLogout() {
  return keycloak.logout({
    redirectUri: window.location.origin
  });
};
var initKeycloakLogin = function initKeycloakLogin(_ref2) {
  var callback = _ref2.callback,
    onError = _ref2.onError,
    _ref2$extraInitConfig = _ref2.extraInitConfiguration,
    extraInitConfiguration = _ref2$extraInitConfig === void 0 ? {} : _ref2$extraInitConfig;
  keycloak = Keycloak(constants.KEYCLOAK_CONFIGURATION);
  return keycloak.init(_objectSpread(_objectSpread({}, constants.INIT_CONFIGURATION), extraInitConfiguration)).then(function (action) {
    return promiseCallback({
      action: action,
      callback: callback,
      onError: onError
    });
  })["catch"](onError);
};
var refreshKeycloakToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3) {
    var onError, domain;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          onError = _ref3.onError;
          domain = cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN);
          if (!(keycloak.isTokenExpired(60) || !isCurrentDomain(domain))) {
            _context.n = 3;
            break;
          }
          _context.n = 1;
          return keycloak.updateToken(60);
        case 1:
          _context.n = 2;
          return promiseCallback({
            onError: onError
          });
        case 2:
          return _context.a(2, _context.v);
        case 3:
          return _context.a(2, true);
        case 4:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function refreshKeycloakToken(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export default {
  doKeycloakLogout: doKeycloakLogout,
  initKeycloakLogin: initKeycloakLogin,
  refreshKeycloakToken: refreshKeycloakToken
};